module.exports = new __parcel__URL__("generic_company.d69273c3.png").toString();